export default "__VITE_ASSET__D3swQiek__"